@let view = vm();
<div class="image-or-file__documents" [attr.data-qa]="'fileUploadInput'">
  @if (!view.readonly) {
    <input
      #documentInput
      class="image-or-file__document-input"
      type="file"
      hidden
      [id]="view.fileInputId"
      [name]="view.fileInputId"
      [accept]="view.accept"
      (change)="onDocumentsPicked(documentInput)"
    />
    <jui-button size="lg" expand [attr.data-qa]="view.key + '_fileUploadButton'" (click)="documentInput.click()">
      <span>{{ view.documentButtonLabel }}</span>
      <span slot="icon" class="material-icons">{{ view.documentButtonIcon }}</span>
    </jui-button>
  }
  @for (name of view.documentNames; track name; let i = $index) {
    <div class="image-or-file__document" [attr.data-qa]="view.key + '_file_' + i">
      <span class="material-icons image-or-file__document-icon">article</span>
      <span class="image-or-file__document-name" [id]="i + '_temp'">{{ name }}</span>
      @if (!view.readonly) {
        <jui-icon
          name="delete_forever"
          isButton="true"
          [attr.data-qa]="view.key + '_removeFile_' + i"
          (click)="removeDocument(i)"
        ></jui-icon>
      }
    </div>
  }
</div>
<div class="image-or-file__images" [attr.data-qa]="'multiImageUploadInput'">
  <jui-image-capture
    [images]="view.images"
    [sort]="view.sort"
    [readonly]="view.readonly"
    [dataqastring]="view.key"
    [inputid]="view.imageInputId"
    (juiImagesChange)="onImagesChange($event)"
    (juiReject)="onReject($event)"
    (juiCaptureRequest)="onCaptureRequest($event)"
    (juiImageClick)="onImageClick($event)"
  >
    @if (view.imageQa) {
      @for (image of view.images; track image.id) {
        <span [attr.slot]="'image-' + image.id + '-overlay'" [attr.data-qa]="view.imageQa"></span>
      }
    }
  </jui-image-capture>
  <question-example-images [examples]="view.examples" [key]="view.key"></question-example-images>
</div>
@if (view.rejection) {
  <p class="image-or-file__rejection" role="alert" [attr.data-qa]="view.key + '_rejection'">{{ view.rejection }}</p>
}
